export default "data:application/octet-stream;base64,LmhvbWUgewogIHBhZGRpbmc6IDEwcHg7Cn0="